export const navigate = (event) => {
    if (window.core && window.core.navigate) {
        window.core.navigate(event);
    }
};
